export { default as TreatingVolumeView } from './TreatingVolumeView';
